import { IntegrationEnum } from 'models/InternalIntegrationSetting';
import AccountingAccessLink from './AccountingAccessLink';
import GuidebooksAccessLink from './GuidebooksAccessLink';
import StaticAccessLink from './StaticAccessLink';

const STATIC_ACCESS_LINK_INTEGRATIONS = [
  IntegrationEnum.HOSTFULLYCAPITAL,
  IntegrationEnum.HOSTFULLYDEVICES,
  IntegrationEnum.HOSTFULLYASSIST,
];

// Dispatch happens before any hook runs so a row only subscribes to the
// request its own access link needs.
const AccessLink = ({ integrationId }: { integrationId: IntegrationEnum }) => {
  if (integrationId === IntegrationEnum.HOSTFULLY) {
    return <GuidebooksAccessLink />;
  }

  if (integrationId === IntegrationEnum.HOSTFULLYACCOUNTING) {
    return <AccountingAccessLink />;
  }

  if (STATIC_ACCESS_LINK_INTEGRATIONS.includes(integrationId)) {
    return <StaticAccessLink integrationId={integrationId} />;
  }

  return null;
};

export default AccessLink;
